'use client';
import { jsx } from 'react/jsx-runtime';
import { useSwanMenuTriggerContext } from './menu-trigger.context.js';
import { BaseTrigger } from '../popover/base-trigger.component.js';
import { useSwanPopover } from '../popover/popover.context.js';

function MenuTrigger({ children: n }) {
    let { triggerRef: m } = useSwanPopover(), { triggerProps: p = {} } = useSwanMenuTriggerContext();
    return jsx(BaseTrigger, {
        triggerRef: m,
        triggerProps: p,
        className: "swan-menu-trigger",
        children: n
    });
}

export { MenuTrigger };
